import { post, get } from '@/utils/request'
// 登录
export const login = (params) => post('/user/login', params)
// 获取考试
export const getUserExam = (params) => post('/question/getUserExam', params)
// 获取考试(分页)
export const getUserExamPaginateApi = (params) => post('/question/getUserExamPaginate', params)
// 获取考试详细信息
export const getExamDetailed = (params) => get('/question/getExam', params)
export const getExamDetail = (params) => post('/question/getExamDetail', params)
// 获取试卷
export const getQuestion = (params) => post('/question/getQuestion', params)
// 获取试题文件
// 校验密码
export const codeCheck = (params) => post('/user/codeCheck', params)
// 发送验证码
export const sendCode = (params) => post('/user/sendCode', params)
// 忘记密码
export const modifyPasswordByMobile = (params) => post('/user/modifyPasswordByMobile', params)
// 获取医院列表
export const userHospital = (params) => get('/user/userHospital', params)
// 获取用户信息
export const getInfo = (params) => post('/user/info', params)
// 修改资料
export const modifyUser = (params) => post('/user/modifyUser', params)
// 上传头像
export const upload = (params) => post('/user/upload', params)
// 修改密码
export const modifyPassword = (params) => post('/user/modifyPassword', params)
// 修改手机号
export const modifyMobile = (params) => post('/user/modifyMobile', params)
// 提交答题记录
export const submitAnswer = (params) => post('/question/answer', params)
// 获取成绩统计
export const getRankList = (params) => post('/question/getRankList', params)
// 获取章节统计
export const getUserAnswerStatistics = (params) => post('/question/getUserAnswerStatistics', params)
// 进入考试
export const joinExam = (params) => post('/user/joinExam', params)
export const joinAndStartExam = (params) => post('/user/joinAndStartExam', params)
// 获取项目
export const getApps = (params) => post('/question/apps', params)
// 获取题目统计视频详情
export const getQuestionAdditional = (params) => post('/question/getQuestionAdditional', params)
// 获取考生成绩
export const getUserFirstAnswerScore = (params) => post('/question/getUserFirstAnswerScore', params)
// 获取考生答案
export const getUserAnswer = (params) => post('/question/getUserAnswer', params)
// 获取考生成绩
export const getAnswerList = (params) => post('/question/getAnswerList', params)
// 获取结束时间
export const severTime = (params) => get('/user/severTime', params)
// 切屏
export const saveCheat = (params) => post('/question/cheat', params)
// 作弊记录批量
export const saveCheatBatch = (params) => post('/question/batchCheat', params)


// 学习模板
export const userVideoStatistics = (params) => get('/studyVideo/userVideoStatistics', params)
export const userVideoList = (params) => get('/studyVideo/userVideoList', params)
export const getSectionList = (params) => get('/studyVideo/getSectionList', params)
export const getVideo = (params) => get('/studyVideo/getVideo', params)
export const studyVideo = (params) => post('/studyVideo/studyVideo', params)

// 获取音视频url
export const getQuestionVideoAudioUrl = (params) => post('/videoAudio/getInfo', params)
// 记录是否首考
export const updateFirstExam = (params) => post('/user/updateFirstExam', params)

export const getNoticeList = (params) => get('/user/getNoticeList', params)
export const getNotReadNoticeCount = (params) => get('/user/getNotReadNoticeCount', params)
export const readNotice = (params) => post('/user/readNotice', params)
export const shengyuRegisterOrLogin = (params) => post('/user/shengyuRegisterOrLogin', params)
export const startExam = (params) => post('/user/startExam', params)
export const answerSubmit = (params) => post('/question/answerSubmit', params)

// 获取试卷的类型
export const getPaperInfoApi = (params) => get('/question/paperInfo', params)

// 注册医考帮
export const registerToYkbApi = (data) => post('/userRegister/registerToYkb', data)
// 获取分组列表
export const getGroupListApi = (params) => get('/userRegister/getGroupList', params)
// 获取身份列表
export const getIdentityListApi = (params) => get('/userRegister/getIdentityList', params)
// 注册至医院
export const registerToHospitalApi = (data) => post('/userRegister/registerToHospital', data)
// 获取注册配置信息
export const globalConfigApi = (params) => get('/user/globalConfig', params)
// 通过考试码获取考试详情
export const getExamInfoApi = (params) => get('/userRegister/getExamInfo', params)

